<template>
  <div class="first-box">
    <div
      v-if="step == 0"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
      "
    >
      <div
        style="
          margin-top: 3vw;
          font-size: 3rem;
          line-height: 3.75rem;
          font-weight: bold;
          color: #b62d2e;
        "
      >
        {{ $t("studentProgramme.sys1") }}
      </div>
      <div style="display: flex; margin-top: 0.5rem; margin-bottom: 3vw">
        <span
          style="
            width: 1rem;
            height: 1rem;
            background: #b62d2e;
            border-radius: 50%;
            margin: 0 0.5rem;
          "
        ></span>
        <span
          style="
            width: 1rem;
            height: 1rem;
            background: #de5934;
            border-radius: 50%;
            margin: 0 0.5rem;
          "
        ></span>
        <span
          style="
            width: 1rem;
            height: 1rem;
            background: #f1aa55;
            border-radius: 50%;
            margin: 0 0.5rem;
          "
        ></span>
      </div>
      <div style="font-size: 2rem; margin-bottom: 3vw">
        {{ $t("studentProgramme.sys2") }}
      </div>
      <div
        v-if="$store.getters.currentWidth <= 768"
        style="
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <img
          class="avatar"
          :class="avatar == item ? 'is-checked' : ''"
          v-for="(item, index) in avatars.slice(0, 3)"
          :key="index"
          :src="item"
          @click="onRadioChange(item)"
        />
      </div>
      <div
        v-if="$store.getters.currentWidth <= 768"
        style="
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <img
          class="avatar"
          :class="avatar == item ? 'is-checked' : ''"
          v-for="(item, index) in avatars.slice(3, 6)"
          :key="index"
          :src="item"
          @click="onRadioChange(item)"
        />
      </div>
      <div
        v-if="$store.getters.currentWidth > 768"
        style="
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <img
          class="avatar"
          :class="avatar == item ? 'is-checked' : ''"
          v-for="(item, index) in avatars"
          :key="index"
          :src="item"
          @click="onRadioChange(item)"
        />
      </div>
      <!-- <el-radio-group @change="onRadioChange" v-model="avatar" style="flex:1;">
                <el-row type="flex" :gutter="20" style="flex-wrap: wrap;height:100%;margin:0;">
                    <el-col v-for="(item, index) in avatars" :key="index" :sm="8" :xs="12" style="height:50%;">
                        <el-radio :label="item" style="height:100%;">
                            <img class="avatar" :src="item"/>
                        </el-radio>
                    </el-col>
                </el-row>
            </el-radio-group> -->
      <button
        class="button"
        @click="putProfile"
        style="margin: 1vw 0; min-width: 5vw"
      >
        {{ $t("studentProgramme.guide6") }}
      </button>
    </div>
    <div
      v-if="step == 1"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
      "
    >
      <div
        style="
          margin-top: 1vw;
          font-size: 2rem;
          line-height: 2.75rem;
          font-weight: bold;
          color: #b62d2e;
        "
      >
        {{ $t("studentProgramme.sys3") }}
      </div>

      <div
        v-if="$store.getters.isPC"
        class="banner-box"
        style="align-items: center"
      >
        <span
          style="margin: 3.5vw; color: white"
          class="el-icon-back"
          @click="carouselPrevious"
        ></span>
        <el-carousel
            :autoplay="false"
            trigger="click"
            arrow="never"
            indicator-position="outside"
            @change="changeItem"
            :height="bannerHeight + 'px'"
            ref="banner"
            style="width: 100%; height: 100%"
        >
          <el-carousel-item v-for="(item, index) in banner" :key="index">
            <!-- 图片类型 -->

            <img class="banner-img" v-if="item.type === 'image'" :src="baseURL + item.image" @load="onLoad" @error="onError" alt="" :style="videoStyle" ref="bannerHeight"/>
            <video class="banner-img" v-else-if="notIframe(item.url)" :style="videoStyle" controls controlslist="nodownload" @loadedmetadata="handleLoadedMetadata" ref="bannerHeight">
              <source :src="item.url" type="video/mp4" ref="bannerHeight"/>
            </video>
            <iframe class="banner-img" v-else :src="item.url" frameborder="0" :style="videoStyle" allow="fullscreen; picture-in-picture; clipboard-write" ref="bannerHeight"> </iframe>
          </el-carousel-item>
        </el-carousel>
        <span
          style="margin: 3.5vw; color: white"
          class="el-icon-right"
          @click="carouselNext"
        ></span>
      </div>
      <div
        v-else
        class="banner-box"
        style="flex-direction: column; justify-content: center"
      >

        <div
          v-if="!$store.getters.isPC"
          style="color: white; display: flex; justify-content: space-evenly"
        >
          <span class="el-icon-back" @click="carouselPrevious"></span>
          <el-carousel
              :autoplay="false"
              trigger="click"
              arrow="never"
              indicator-position="outside"
              @change="changeItem"
              :height="bannerHeight + 'px'"
              ref="banner"
              style="width: 100%; height: 100%"
          >
            <el-carousel-item v-for="(item, index) in banner" :key="index">
              <!-- 图片类型 -->
              <img
                  v-if="isImage(item)"
                  class="banner-img"
                  :src="baseURL + item.image"
                  @load="imgLoad"
                  ref="bannerHeight"
              />

              <!-- 视频类型 -->
              <video
                  v-else-if="isVideo(item)"
                  class="banner-video"
                  :poster="baseURL + item.image"
              >
                <source :src="item.url" type="video/mp4">

              </video>
            </el-carousel-item>
          </el-carousel>
          <span class="el-icon-right" @click="carouselNext"></span>
        </div>
      </div>
      <button
          class="button"
          @click="firstFinish"
          style="margin: 1vw 0; min-width: 5vw"
      >
        {{ $t("studentProgramme.guide6") }}
      </button>
    </div>

  </div>
</template>

<script>
import { putProfile } from "@/api/user";
import { getBanners } from "@/api/setting";
import { setUserInfo } from "@/utils/auth";
import cmi from "../cmi";
import { isPC, isPad } from "@/utils/is-rules";
export default {
  props: {
    detail: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    return {
      step: 0,
      avatar: null,
      avatars: [],
      tabIndex: 0,
      banner: [],
      bannerHeight: null,
      baseURL: process.env.VUE_APP_URL,
      videoStyle: {},
    };
  },
  created() {
    this.getAvatars();
    this.getBanners();
  },
  mounted() {
    this.$store.dispatch("setWidth", window.innerWidth);
    window.onresize = () => {
      return (() => {
        this.$store.dispatch("setWidth", window.innerWidth);
        this.$store.dispatch("setIsPC", isPC());
        this.$store.dispatch("setIsPad", isPad());
        if (this.step == 1) this.imgLoad();
      })();
    };
  },
  destroyed() {
    window.onresize = null;
  },
  methods: {
    getVideoStyle() {
      let innerWidth = window.innerWidth - 15;
      let innerHeight = window.innerHeight;
      let maxWidth = innerWidth * 0.7 - 40;
      // let maxHeight = innerHeight - 215;
      let maxHeight = innerHeight - 225;
      let changeHeight = maxWidth / this.aspectRatio;
      let changeWidth = maxHeight * this.aspectRatio;
      if (changeHeight >= maxHeight) {
        this.videoStyle = {
          width: changeWidth + "px",
          height: maxHeight + "px",
          display: "block",
        };
      } else if (changeWidth >= maxWidth) {
        this.videoStyle = {
          width: maxWidth + "px",
          height: changeHeight + "px",
          display: "block",
        };
      }
    },
    handleLoadedMetadata() {
      this.isLoading = false;
      this.hasLoaded = true;
      this.getVideoStyle();
      // this.videoStyle = {
      //     width: "100%",
      //     maxHeight: "calc(100vh - 225px)",
      //     display: "block",
      // };
    },
    notIframe(url) {
      return url.includes(window.location.hostname);
    },
    // 判断是否是图片
    isImage(item) {
      return item.type === 'image';
    },
    // 判断是否是视频
    isVideo(item) {
      return item.type === 'video';
    },
    handleCarouselChange(index) {
      const videos = document.querySelectorAll('.banner-video');
      videos.forEach((video, i) => {
        if (i !== index) {
          video.pause();
        } else {
          video.play();
        }
      });
    },
    onRadioChange(v) {
      this.avatar = v;
    },
    getAvatars() {
      let list = [
        "/avatars/avatar_1.jpg",
        "/avatars/avatar_2.jpg",
        "/avatars/avatar_3.jpg",
        "/avatars/avatar_4.jpg",
        "/avatars/avatar_5.jpg",
        "/avatars/avatar_6.jpg",
      ];
      this.avatars = list.map((item) => {
        return `${process.env.VUE_APP_URL}` + item;
      });
    },
    putProfile() {
      let detail = JSON.parse(JSON.stringify(this.detail));
      detail.avatar = this.avatar;
      putProfile(detail).then(() => {
        this.step = 1;
        cmi.$emit("avatarChange", this.avatar);
        this.detail.avatar = this.avatar;
        setUserInfo("userProfile", this.detail);
      });
    },
    changeItem(e) {
      this.handleCarouselChange();
      this.tabIndex = e;
    },
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[this.tabIndex].height;
      });
      this.$forceUpdate();
    },
    getBanners() {
      // let arr=[{title:"冒险模式",
      //     image:"http://testingapi.mathconceptonline.com/uploads/images/MQiXpkyfGy7jOeUaCB2IWeoOKS9LwafHIDyPX2H4.png"
      //     },{title:"图书馆模式",
      //     image:"http://testingapi.mathconceptonline.com/uploads/images/MQiXpkyfGy7jOeUaCB2IWeoOKS9LwafHIDyPX2H4.png"
      //     },{title:"冒险模式2",
      //     image:"http://testingapi.mathconceptonline.com/uploads/images/MQiXpkyfGy7jOeUaCB2IWeoOKS9LwafHIDyPX2H4.png"
      //     },{title:"图书馆模式2",
      //     image:"http://testingapi.mathconceptonline.com/uploads/images/MQiXpkyfGy7jOeUaCB2IWeoOKS9LwafHIDyPX2H4.png"
      // }]
      // this.banner = arr
      getBanners().then((v) => {
        // this.banner.image = v.data.map((item) => {
        //   return `${process.env.VUE_APP_URL}` + item.image;
        // });
        this.banner = v.data;
      });
    },
    //轮播图上一张
    carouselPrevious() {
      this.$refs.banner.prev();
    },
    //轮播图下一张
    carouselNext() {
      this.$refs.banner.next();
    },
    firstFinish() {
      this.$emit("update:isFirst", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.first-box {
  border-radius: 4.5rem;
  background: #ffffff;
  width: 100%;
  height: 100%;
}
.avatar {
  //max-height:calc(50vh - 9.5vw - 8.125rem);
  max-width: calc(14vw - 20px);
  border: 1vw solid #ffffff;
  border-radius: 50%;
}
.is-checked.avatar {
  border: 1vw solid #fcc03a;
}
.button {
  background: #fcc03a;
  box-shadow: 0px 0.5rem 0 #c28c00;
  border: none;
  border-radius: 2.75rem;
  font-size: 1.5rem;
  line-height: 1.5rem;
  padding: 0.25rem 1rem;
}
.banner-box {
  display: flex;
  justify-content: space-between;
  width: 120%;
  flex: 1;
}
.banner-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  //aspect-ratio: 20/9;
}
[class^="el-icon-"] {
  background: #fcc03a;
  box-shadow: 0px 0.25rem 0 #c28c00;
  border: none;
  border-radius: 50%;
  font-size: 2rem;
  font-weight: bold;
}
::v-deep {
  .el-radio__input {
    display: none;
  }
  .el-radio__label {
    padding: 0;
  }
  .el-carousel__container {
    width: 100%;
    height: calc(100% - 3rem) !important;
  }
  .el-carousel__indicator--horizontal {
    padding: 0.75rem;
    button {
      background-color: #e2abab;
      opacity: 1;
      //width: 1.5rem;
      //height: 1.5rem;
      border-radius: 50%;
    }
    &.is-active button {
      background-color: #b62d2e;
    }
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .avatar {
    max-height: calc(50vh - 9.5vw - 8.125rem);
    max-width: calc(28vw - 20px);
  }
}
</style>
